// @flow

/**
 * Module dependencies.
 */

import { defaultTo } from 'lodash';
import { isProduction } from 'core/utils/environment';
import config from 'config';

/**
 * Export `asset`.
 */

export function asset(assetPath: string): string {
  return isProduction() ? `${defaultTo(config.basePath, '')}${assetPath}` : assetPath;
}



// WEBPACK FOOTER //
// ../src/core/utils/assets.js